import { LoadingOutlined } from "@ant-design/icons";

const PrimaryButton = ({
  loading = false,
  disabled = false,
  additionalstyle = "",
  text = "",
  icon = "",
  iconalign = "",
  ...rest
}) => {
  const style = loading
    ? `w-full rounded-xl bg-secondaryPressed font-medium text-[16px] text-white h-12 opacity-50 flex justify-center items-center px-2 py-1 whitespace-nowrap overflow-hidden text-ellipsis gap-3 ${
        disabled && "opacity-60"
      }`
    : `w-full rounded-xl bg-secondary font-medium text-[16px] text-white h-12 flex justify-center items-center px-2 py-1 whitespace-nowrap overflow-hidden text-ellipsis gap-3 ${
        disabled && "opacity-60"
      }`;

  return (
    <button {...rest} className={style}>
      {icon && iconalign === "left" && <img src={icon} alt="icon" />}{" "}
      <p
        className="mb-0 whitespace-nowrap overflow-hidden text-ellipsis"
        title={text}
      >
        {text}
      </p>{" "}
      {icon && iconalign === "right" && <img src={icon} alt="icon" />}
      {loading && (
        <LoadingOutlined style={{ fontSize: 20, color: "white" }} spin />
      )}
    </button>
  );
};

export default PrimaryButton;
